<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <!-- <div class="item">试卷分类名称：{{form.beforeStr.name}}</div> -->
          <div class="item">状态：{{form.beforeStr.courseTopic.state?'启用':'禁用'}}</div>
          <div class="item">题目解析：{{form.beforeStr.courseTopic.resolution_content}}</div>
          <div class="title-box"><span class="txt1">题目信息</span></div>
          <el-descriptions :column="1">
            <el-descriptions-item label="题目">{{form.beforeStr.courseTopic.title}}</el-descriptions-item>
            <el-descriptions-item v-for="(item,index) in form.beforeStr.courseTopicAnswer" :key="index" :label="'选项'+item.code">{{item.content}}</el-descriptions-item>
          </el-descriptions>
          <!-- <div class="title-box"><span class="txt1">答案与解析</span></div>
          <el-descriptions :column="1">
            <el-descriptions-item label="正确答案">{{form.beforeStr.correctAnswer}}</el-descriptions-item>
            <el-descriptions-item label="题目解析">{{form.beforeStr.courseTopic.resolutionContent}}</el-descriptions-item>
          </el-descriptions> -->
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <!-- <div class="item">试卷分类名称：{{form.afterStr.name}}</div> -->
          <div class="item">状态：{{form.afterStr.courseTopic.state?'启用':'禁用'}}</div>
          <div class="item">题目解析：{{form.afterStr.courseTopic.resolution_content}}</div>
          <div class="title-box"><span class="txt1">题目信息</span></div>
          <el-descriptions :column="1">
            <el-descriptions-item label="题目">{{form.afterStr.courseTopic.title}}</el-descriptions-item>
            <el-descriptions-item v-for="(item,index) in form.afterStr.courseTopicAnswer" :key="index" :label="'选项'+item.code">{{item.content}}</el-descriptions-item>
          </el-descriptions>
          <!-- <div class="title-box"><span class="txt1">答案与解析</span></div>
          <el-descriptions :column="1">
            <el-descriptions-item label="正确答案">{{form.afterStr.correctAnswer}}</el-descriptions-item>
            <el-descriptions-item label="题目解析">{{form.afterStr.courseTopic.resolutionContent}}</el-descriptions-item>
          </el-descriptions> -->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        
        this.form = res.data;

      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
